export interface EventGroupLike {
  name: string;
}

export const isEventInGroup = (
  eventGroups: EventGroupLike[] | undefined | null,
  targetGroupName: string,
  viewerGroupName: string | null
) => {
  const groups = eventGroups ?? [];

  if (groups.length) {
    return groups.some((group) => group.name === targetGroupName);
  }

  return viewerGroupName === targetGroupName;
};
